import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoginState {
  email_address: string;
  password: string;
  loading: boolean; // To manage the loading state
  errors: Record<string, string>; // To store error messages for each field
  isOtpStep: boolean; // To track if OTP step is active
  nextStep: any; // Stores the next step in the login process
  otpErrors: string; // To handle OTP-specific errors
  fieldError : string;
}

const initialState: LoginState = {
  email_address: '',
  password: '',
  loading: false,
  errors: {}, // Initialize with an empty object for error messages
  isOtpStep: false,
  nextStep: null,
  otpErrors: '',
  fieldError : ''
};

interface UpdatePayload {
  field: 'email_address' | 'password';
  value: string;
}

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    updateField(state, action: PayloadAction<UpdatePayload>) {
      const { field, value } = action.payload;
      state[field] = value;

      // Clear the error for the field when it is updated
      if (state.errors[field]) {
        delete state.errors[field];
      }
    },
    resetLogin(state) {
      state.email_address = '';
      state.password = '';
      state.loading = false;
      state.errors = {}; // Reset error messages
      state.isOtpStep = false;
      state.nextStep = null;
      state.otpErrors = '';
      state.fieldError = '';
    },
    setFieldError(state, action:  PayloadAction<string>) {
      state.fieldError = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload; // Set the loading state
    },
    setErrors(state, action: PayloadAction<Record<string, string>>) {
      state.errors = action.payload; // Update the errors object
    },
    startOtpStep(state, action: PayloadAction<any>) {
      state.isOtpStep = true; // Activate OTP step
      state.nextStep = action.payload; // Store next step information
      state.loading = false;
    },
    setOtpError(state, action: PayloadAction<string>) {
      state.otpErrors = action.payload; // Update OTP error message
    },
  },
});

export const { 
  updateField, 
  resetLogin, 
  setLoading, 
  setErrors, 
  startOtpStep, 
  setOtpError,
  setFieldError
} = loginSlice.actions;

export default loginSlice.reducer;
